<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import TgModal from "@/abc-dsk/components/Modal/TgModal.vue";
import ActionWithTooltip from "@/components/ActionWithTooltip.vue";

defineProps<{
  wordclass: string;
  wordclassShortForm: string;
  title: string;
}>();

const emits = defineEmits<{
  (e: "mouseover", event: MouseEvent): void;
  (e: "mouseout", event: MouseEvent): void;
}>();

const { t } = useI18n();

const isModalOpen = ref(false);
</script>

<template>
  <ActionWithTooltip hide-on-click>
    <template #element>
      <button
        class="article-header__word-class article-header__word-class--with-action"
        :aria-label="t('article.wordclass.label', { wordclass })"
        @mouseover="emits('mouseover', $event)"
        @mouseout="emits('mouseout', $event)"
        @click.stop="isModalOpen = true"
      >
        {{ wordclassShortForm }}
      </button>
    </template>
    <template #actionInitial>{{ title }}</template>
  </ActionWithTooltip>
  <TgModal :is-open="isModalOpen" @close="isModalOpen = false">
    <template #modal-header>{{ title }}</template>
    <slot />
  </TgModal>
</template>
